var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-page"},[_c('TitlePage'),_c('CommonTitle',{attrs:{"text":_vm.text,"cont":_vm.cont}}),_c('div',{staticClass:"cont-container"},[_c('div',{staticClass:"cont-box"},[_c('div',{staticClass:"contL"},[_c('router-view')],1),(_vm.fullWidth>900)?_c('div',[_c('User')],1):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }